import * as React from 'react';
import { connect } from 'react-redux';
import { IBasePageProps } from '../../../../configuration/IConfiguration';
import * as DTOS from "../../../../../../FeralScan.dtos";
import { bindActionCreators } from 'redux';
import { IAppState } from '../../../../../../app';
import * as DataActionCreators from "../../../../../../actions/data.actions";
import * as MapActionCreators from "../../../../../../actions/map.actions";
import * as moment from 'moment';
import { withRouter } from 'react-router';
import { History } from 'history';
import InternalClassificationLink from '../../../../Common/Links/InternalClassificationLink';
import { Link } from 'react-router-dom';
import Loader from 'react-loaders';
import { sortPlots, PlotSortBy } from '../../../../../../helpers/graphHelper';
import PaginatedTable, { ISortOption } from '../../../../../Data/PaginatedTable/PaginatedTable';


interface IPageMyDataProps {
    aDifferentProp: string;
    selectPlots: (state?: IAppState, ownProps?: PageMyDataOwnProps) => DTOS.Plot[];
    history: History;
    userSummaryData: DTOS.PlatypusUserPlotsEventsSummary;
}

interface IPageMyDataRouteParams {
}

interface IPageMyDataQueryParams {
}

interface IPageMyDataMapped {
    plots?: DTOS.Plot[];
    plotsLoading?: boolean;

    showScanDetail?: typeof MapActionCreators.showEventRequest;
    getUserPlots?: typeof DataActionCreators.getUserPlotsRequest;
    getUserPlotEventSummaryData?: typeof DataActionCreators.getUserPlotEventSummaryDataRequest;
}

type PageMyDataOwnProps = IBasePageProps<IPageMyDataRouteParams, IPageMyDataQueryParams> & IPageMyDataProps;

type PageMyDataProps = PageMyDataOwnProps & IPageMyDataMapped;

const myDataSearchOrderKey = 'myDataSearchOrder';

interface IPageMyDataState {
    sortOrder: string;
}

class PageMyData extends React.Component<PageMyDataProps, IPageMyDataState> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            sortOrder: undefined
        }

        this.onSortChange = this.onSortChange.bind(this);
        this.average = this.average.bind(this);
    }

    componentDidMount() {
        if (!this.props.plotsLoading && !this.props.plots) {
            this.props.getUserPlots(false);
        }

        if (this.props.currentUser && this.props.currentUser.userPreferences) {
            const sortOrder = this.props.currentUser.userPreferences[myDataSearchOrderKey]
                ? this.props.currentUser.userPreferences[myDataSearchOrderKey]
                : 'NAME';

            this.setState({
                sortOrder: sortOrder
            });
        }

        this.props.getUserPlotEventSummaryData();
    }

    componentDidUpdate(prevProps: PageMyDataProps) {
        if (this.props.currentUser && (!this.props.currentUserLoading && prevProps.currentUserLoading)) {
            if (this.props.currentUser.userPreferences[myDataSearchOrderKey]) {
                this.setState({
                    sortOrder: this.props.currentUser.userPreferences[myDataSearchOrderKey]
                });
            }
        }
    }

    onSortChange(obj) {
        this.setState({
            sortOrder: obj.value
        });

        this.props.setUserPreference(myDataSearchOrderKey, obj.value);
    }

    average(sum: number, total: number) {
        if (!this.props.plots) return 'N/A';
        if (total == 0) return 'N/A';

        return (sum / total);
    } 

    render() {
        const SortPlotsChoices: ISortOption[] = [
            { value: PlotSortBy.DATESELECTED, label: 'According to when they were registered' },
            { value: PlotSortBy.MYSCANSCOUNT, label: 'According to how many scans I\'ve made there' },
            { value: PlotSortBy.LASTSCANNED, label: 'According to when they were most recently scanned by me' },
            { value: PlotSortBy.NAME, label: 'Alphabetically by site name' }
        ]

        return (
            <div className="m-md-4 m-2">
                <div className="col-12 border-bottom my-2 pb-2">
                    <h2 className="m-0">My Data</h2>
                </div>

                {this.props.plots && this.props.plots.length > 0 ?
                    <>
                        <div className="user-summary-data">
                            {
                                this.props.userSummaryData ?
                                    <>
                                        <div>My last scan: {this.props.userSummaryData.lastScan ? moment(this.props.userSummaryData.lastScan).format(this.props.defaultDateFormat) : "Never"}</div>
                                        <div>My total scans: {this.props.userSummaryData.totalScans}</div>
                                        <div>My total platypus sightings: {this.props.userSummaryData.platypusCount}</div>
                                        <div>% of scans in prime platypus viewing time:
                                            {this.props.userSummaryData.totalScans > 0
                                                ? <span> {((this.props.userSummaryData.totalScansInPrimeTime / this.props.userSummaryData.totalScans) * 100).toFixed(1)}%</span>
                                                : 'N/A'
                                            }
                                        </div>
                                        <div>My total scans in current reporting quarter: {this.props.userSummaryData.totalScansCurrentQuarter}</div>
                                    </> : undefined
                            }
                        </div>

                        <PaginatedTable
                            countPerPage={25}
                            data={this.props.plots}
                            dataColumns={[
                                { 
                                    className: "align-middle w-10",
                                    dataKey: undefined,
                                    label: undefined, 
                                    render: (p: DTOS.Plot) => InternalClassificationLink(`site/${p.id}/add-data`, 'Add Data', 'fa-plus-square p-1', 'btn btn-primary')
                                },
                                { 
                                    className: "align-middle clickable",
                                    dataKey: "name" ,
                                    label: "Site Name", 
                                    onClick: (p: DTOS.Plot) => this.props.history.push(`site/${p.id}`),
                                },
                                {
                                    className: "align-middle d-none d-lg-table-cell clickable",
                                    classNameHeader: "d-none d-lg-table-cell",
                                    dataKey: undefined,
                                    label: "My Last Scan",
                                    onClick: (p: DTOS.Plot) => this.props.history.push(`site/${p.id}`),
                                    render: (p: DTOS.Plot) => p.userNewestPlotEventDate ? moment(p.userNewestPlotEventDate).format(this.props.defaultDateFormat) : 'Never'
                                },
                                {
                                    className: "align-middle d-none d-lg-table-cell clickable",
                                    classNameHeader: "d-none d-lg-table-cell",
                                    dataKey: undefined,
                                    label: "My Total Scans",
                                    onClick: (p: DTOS.Plot) => this.props.history.push(`site/${p.id}`),
                                    render: (p: DTOS.Plot) => p.userPlotEventsCount
                                },
                                {
                                    className: "align-middle d-none d-lg-table-cell clickable",
                                    classNameHeader: "d-none d-lg-table-cell",
                                    dataKey: undefined,
                                    label: "My Total Sightings",
                                    onClick: (p: DTOS.Plot) => this.props.history.push(`site/${p.id}`),
                                    render: (p: DTOS.Plot) => p.userTotalSightingsCount
                                },
                                {
                                    className: "align-middle d-none d-lg-table-cell clickable",
                                    classNameHeader: "d-none d-lg-table-cell",
                                    dataKey: undefined,
                                    label: "My Average Sightings / Scan",
                                    onClick: (p: DTOS.Plot) => this.props.history.push(`site/${p.id}`),
                                    render: (p: DTOS.Plot) => this.average(p.userTotalSightingsCount, p.userPlotEventsCount)
                                },
                                {
                                    className: "align-middle clickable",
                                    dataKey: undefined,
                                    label: undefined,
                                    onClick: (p: DTOS.Plot) => this.props.history.push(`site/${p.id}`),
                                    render: (p: DTOS.Plot) => <i className="btn btn-primary fa fa-arrow-right"/>
                                },
                            ]}
                            dataLoading={this.props.plotsLoading}
                            dataSortOptions={SortPlotsChoices}
                            sort={sortPlots}
                            tableClassName={"table-hover"}
                            setUserPreference={this.props.setUserPreference}
                            userPreferenceKey={myDataSearchOrderKey}
                        />
                        <p>If you see a platypus at a location other than one of your registered sites, please report the details via the <a rel="noopener" href='https://platypus.asn.au/report-a-sighting/'>APC website Report a Sighting</a> page. Sightings of water-rats/rakali can also be reported in this way.</p>
                    </>
                    : this.props.plotsLoading ? <div className="position-absolute"
                        style={{ bottom: '50%', left: '42%' }}>
                        <Loader type="ball-scale-multiple" active />
                        <div className="ml-4 small">please wait, loading sites</div>
                    </div>
                        : <h2 className="text-center mt-5">You are not currently monitoring any sites.</h2>
                }
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageMyDataProps) => {

    /*const plots = ownProps.selectPlots ?
        ownProps.selectPlots(state) :
        state.data.userPlots
        ;*/

    return {
        plots: state.data.userPlots,
        plotsLoading: state.data.userPlotsLoading,
        userSummaryData: state.data.userPlotEventSummaryData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        showScanDetail: MapActionCreators.showEventRequest,
        getUserPlots: DataActionCreators.getUserPlotsRequest,
        getUserPlotEventSummaryData: DataActionCreators.getUserPlotEventSummaryDataRequest,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PageMyData));